import http from "./http";

export interface ClientSidenavAssignment {
  id?: number | string;
  sidenav_item?: {
    id?: number | string;
  } | null;
}

export const getClientSidenavItems = async (
  clientId: string | number
): Promise<ClientSidenavAssignment[]> => {
  const response = await http.get(`/api/client-sidenav-items/${clientId}`);
  return Array.isArray(response.data) ? response.data : [];
};

export const saveClientSidenavItems = async (
  clientId: string | number,
  sidenavItemIds: (string | number)[]
) => {
  return http.post("/api/client-sidenav-items", {
    client_id: clientId,
    sidenav_item_ids: sidenavItemIds,
  });
};

export const deleteClientSidenavItem = async (
  id: string | number
): Promise<unknown> => {
  return http.delete(`/api/client-sidenav-items/${id}`);
};
